// D:\my-website\src\components\IndustryDynamicsPage.js

import React from 'react';
import { useTranslation } from 'react-i18next';

function IndustryDynamicsPage({ industryDynamicsContent }) {
  const { t } = useTranslation();

  // 确保 industryDynamicsContent 存在，否则使用空对象
  const data = industryDynamicsContent || {};

  // 假设 industryDynamicsContent.newsItems 是一个包含新闻对象的数组
  const newsItems = data.newsItems || [];

  return (
    <section id="industry-dynamics" className="py-16 md:py-24 bg-white rounded-lg shadow-md m-4">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-10 section-title">{t('industry_dynamics')}</h2>

        <div className="space-y-12">
          {newsItems.length > 0 ? (
            newsItems.map((news, index) => (
              <div key={news.id || index} className="bg-gray-50 p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-semibold text-gray-800 mb-4">{news.title}</h3>
                <div className="flex flex-wrap items-center text-gray-600 text-sm mb-4">
                  <p className="mr-4">
                    <strong className="font-medium">{t('news_date_label')}:</strong> {news.date}
                  </p>
                  <p>
                    <strong className="font-medium">{t('news_media_label')}:</strong> {news.media}
                  </p>
                </div>
                <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                  {news.content}
                </p>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-600 text-lg">{t('no_industry_dynamics_content')}</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default IndustryDynamicsPage;
